/*
 * @Description:运单列表
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-06-26 11:27:16
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { getRouteListByBid, getProjectListByBid } from '@/api/common';
import { waybillZyList, getstatusStatistic, waybillexport } from '@/api/waybill';
import { filterTestCorp } from '@/utils/util';
import { extent } from '@/utils/dictionary/waybillselect';

const storeModuleName = 'waybillzyModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'routeInfoName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'driverInfoNames',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNos',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'date-picker',
      param: 'waybillCreateTime',
      value: [],
      valueType: 'date',
      label: '装货时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['loadStartTime', 'loadEndTime'],
    },
    {
      style: 'date-picker',
      param: 'payTime',
      value: [],
      valueType: 'date',
      label: '卸货时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['unloadStartTime', 'unloadEndTime'],
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'input',
      param: 'createName',
      value: '',
      valueType: 'string',
      label: '创建人',
      placeholder: '请输入创建人姓名',
      clearable: true,
    },
    {
      style: 'select',
      param: 'carryCargoLength',
      value: '',
      valueType: 'string',
      state: 'extent',
      label: '载货长度',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '运单状态',
      name: 'waybillStatus',
      value: '',
      selectList: [
        {
          value: '',
          label: '全部',
          isActive: false,
          countName: '',
          count: 0,
        },
        {
          value: 'WAYBILL_WAIT',
          label: '待接单',
          isActive: false,
          countName: 'WAYBILL_WAIT',
          count: 0,
        },
        {
          value: 'WAYBILL_PUSH',
          label: '待装货',
          isActive: false,
          countName: 'WAYBILL_PUSH',
          count: 0,
        },
        {
          value: 'WAYBILL_START',
          label: '运输中',
          isActive: false,
          countName: 'WAYBILL_START',
          count: 0,
        },
        {
          value: 'WAYBILL_END',
          label: '已卸货',
          isActive: false,
          countName: 'WAYBILL_END',
          count: 0,
        },
      ],
    },
  ],
  // 导出
  isExport: {
    isShow: true,
    method: 'get',
    url: waybillexport,
  },
  // 页码
  postParams: {
    page: 1,
    size: 20,
    routeInfoId: '',
    projectId: '',
    oneselfCreated: 'N',
    waybillFailed: '',
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单信息',
        prop: 'waybillNo',
        width: 220,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillNo',
      },
      {
        label: '运单状态',
        prop: 'waybillStatus',
        width: 220,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillStatus',
      },
      {
        label: '运力信息',
        prop: 'driverInfoNames',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-driverInfoNames',
      },
      {
        label: '装卸货',
        prop: 'orderName',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-orderName',
      },
      {
        label: '运单时间',
        prop: 'waybillTime',
        width: 170,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-startTime',
      },
      {
        label: '成本（元）',
        prop: 'totalCost',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-totalCost',
      },
      {
        label: '异常提示',
        prop: 'monitorType',
        width: 200,
        checked: 1,
        fixed: 'right',
        sortable: true,
        slotName: 'sub-domain-monitorType',
      },
      {
        label: '操作',
        width: 120,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
    total: 0,
    statistic: { totalCost: 0 },
  },
  payStatusList: '', // 支付状态统计
  companyList: [], // 企业列表
  channelInfos: [], // 网络货运平台列表
  companyInfo: '', // 当前选中的企业信息
  payPwdExist: '', // 是否设置支付密码
  payPwdStatus: '', // 是否启用支付密码
  extent, // 载货长度
  filterTestCorp,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    // 获取统计信息
    context.dispatch('getStatistics');
    const { data } = await waybillZyList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign(
        {},
        context.state.listData,
        { list: data.page.records },
        { total: data.page.total },
        { statistic: data.statistic },
      ),
    });
    // context.dispatch('scheduledTask');
    return data.records;
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await getstatusStatistic({
      businessId: context.state.parameters[0].value,
    });
    context.commit('updateState', {
      key: 'payStatusList',
      value: data.list,
    });
    data.list.forEach(item => {
      const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
        return selectItem.value === item.type;
      });
      context.commit('updateButtonValueFromIndex', {
        index,
        value: item.count,
      });
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = context.state.filterTestCorp(item.principalPartName);
          //   item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        lineType: 'own',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams.oneselfCreated = 'N';
    state.postParams.waybillFailed = '';
    state.postParams.routeInfoId = '';
    state.postParams.projectId = '';
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
    state.isSpecialButton.forEach(item => {
      item.value = '';
      item.selectList.forEach(select => {
        select.isActive = item.value.includes(select.value);
      });
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        break;
      case 'routeInfoName':
        state.postParams.routeInfoId = payload.id;
        break;
      default:
        break;
    }
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    specialData.value = payload.value;
    specialData.selectList.forEach(item => {
      item.isActive = item.value === payload.value;
    });
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
  upOneselfCreated(state, payload) {
    state.postParams.oneselfCreated = payload;
  },
  updateFail(state, payload) {
    state.postParams.waybillFailed = payload;
  },
  upWaybillFailed(state, payload) {
    state.postParams.waybillFailed = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
